export default __webpack_public_path__ + "static/media/haj2.9ac6e89d.JPG";